import {SnLink } from "./typography/SnLink"
import { Text, TextProps } from "@chakra-ui/react";

export const Copyright = (props: TextProps) => {
  return (
    <Text fontSize="12px" lineHeight="16px" color="khaki" {...props}>
      Copyright © 2023-2024. All rights reserved. Created by <SnLink to="https://atcontent.fi/" target="_blank">John Nurminen Foundation</SnLink> and <SnLink to="https://www.indevit.fi/" target="_blank">Indevit</SnLink>
    </Text>
  )
}